module.exports = __webpack_public_path__ + "media/customizations/bridgelandlife/back-3302b5ab7116df7df1a172c7a2e8f232.jpg";